import { AHIcon, AHText, Box } from "arkh";
import React, { useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import { DateTime } from "luxon";
import { ProductExpireBatchListItemAction_StoreProductExpireBatchAction$key } from "./__generated__/ProductExpireBatchListItemAction_StoreProductExpireBatchAction.graphql";
import { StoreRelativeZonedDate } from "../ProductExpireBatch/StoreRelativeZonedDate";

export function ProductExpireBatchListItemAction(props: {
  productExpireBatchAction: ProductExpireBatchListItemAction_StoreProductExpireBatchAction$key;
}) {
  const action = useFragment(
    graphql`
      fragment ProductExpireBatchListItemAction_StoreProductExpireBatchAction on StoreProductExpireBatchAction {
        id
        label
        status
        startAtDate {
          isoString
          timezone
          ...StoreRelativeZonedDate_StoreZonedDate
        }
      }
    `,
    props.productExpireBatchAction
  );

  const started = useMemo(() => {
    const normalizedDate = (d: DateTime) =>
      d.setZone(action.startAtDate.timezone).set({
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
      });
    return (
      normalizedDate(DateTime.fromISO(action.startAtDate.isoString)) <=
      normalizedDate(DateTime.now())
    );
  }, [action.startAtDate]);

  const dateColor = useMemo(() => {
    if (started && action.status !== "COMPLETED") {
      return action.status === "INFO" ? "negative" : "primary";
    }
    return "text-washed";
  }, [started, action.status]);

  return (
    <Box
      style={{ flexDirection: "row", alignItems: "center" }}
      spaceTop="medium"
    >
      <AHText
        type="subtitle"
        style={{
          flex: 1,
        }}
        color={
          started && action.status !== "COMPLETED"
            ? "text-primary"
            : "text-washed"
        }
      >
        {action.label}
      </AHText>
      <AHText type="subtitle" color={dateColor}>
        <StoreRelativeZonedDate zonedDate={action.startAtDate} />
      </AHText>
      <AHIcon
        type={action.status === "INFO" && started ? "flag" : "clock"}
        size="small"
        spaceLeft="xsmall"
        color={dateColor}
      />
    </Box>
  );
}
